
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["click"],
  props: {
    clickable: {
      type: Boolean,
      default: false
    }
  }
});
